import React from 'react';
import {
  Col,
  Form,
  FormItemProps,
  Input,
  InputProps,
  Row,
  Typography,
} from 'antd';
import { useController, UseControllerProps } from 'react-hook-form';
import { REGEX } from 'src/constants/app';

type Props<T> = {
  inputProps?: InputProps;
  controller: UseControllerProps<T>;
  errorCol?: 12 | 24;
} & Omit<FormItemProps, 'children'>;

function HalfWidthInputField<T extends Record<string, any>>(props: Props<T>) {
  const { inputProps, controller, errorCol = 24, label, ...rest } = props;
  const { fieldState, field } = useController<T>(controller);
  const { error } = fieldState;

  const onChange = (v) => {
    if (inputProps?.maxLength) {
      if (v.target.value?.length <= inputProps?.maxLength) {
        _onChangeValue(v.target.value);
      }
    } else {
      _onChangeValue(v.target.value);
    }
  };

  const _onChangeValue = (v) => {
    // only allow half-width character
    if (REGEX.REGEX_ONLY_HALFWIDTH_CHARACTERS.test(v) || v === '') {
      field.onChange(v);
    } else {
      !field.value && field.onChange('');
    }
  };

  return (
    <Form.Item
      colon={false}
      label={label}
      labelAlign="left"
      labelCol={label ? { span: 24 } : undefined}
      wrapperCol={label ? { span: 24 } : undefined}
      validateStatus={error ? 'error' : ''}
      {...rest}
    >
      <Row gutter={4}>
        <Col span={errorCol}>
          <Row gutter={8}>
            <Col span={24}>
              <Input
                {...field}
                {...inputProps}
                style={{ width: '100%' }}
                onChange={onChange}
              />
            </Col>
          </Row>
        </Col>
        {error && (
          <Col span={errorCol}>
            <Typography.Text
              className="ant-form-item-explain ant-form-item-explain-error"
              type="danger"
              ellipsis={{ tooltip: false }}
              style={{
                lineHeight: errorCol === 24 ? '16px' : '42px',
                overflow: 'visible',
              }}
            >
              {error.message}
            </Typography.Text>
          </Col>
        )}
      </Row>
    </Form.Item>
  );
}

export default HalfWidthInputField;
